import { createFileRoute } from '@tanstack/react-router';
import { Users } from 'lucide-react';
import { UserTable } from '@/components/users/UserTable';

export const Route = createFileRoute('/_admin/usuarios/')({
  component: UsuariosPage,
});

function UsuariosPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <Users className="h-7 w-7" />
            Gestão de Usuários
          </h1>
          <p className="text-muted-foreground">
            Visualize e gerencie todos os usuários cadastrados
          </p>
        </div>
      </div>

      <UserTable />
    </div>
  );
}
